"use strict";

/*
 ## External Dependencies ##
 - Mixpanel
 */

var Reflux = require("reflux");
var agendorAPI = require("app/util/api/agendor-api");
var searchAPI = require("app/util/api/search");

var searchTimeout = null;
var searchDelay = 400;

var MultiActionStore = require("app/util/flux/multi-action-store");

function createActions(instanceKey) {

  var actions = Reflux.createActions({
    "showSuggestions": {children: ["started", "completed", "failed"]},
    "hideSuggestions": {},
    "selectSuggestion": {},
    "clearSelected": {},
    "addOrganization": { children: ["started", "completed", "failed"] },
    "addPerson": { children: ["started", "completed", "failed"] },
    "addDeal": { children: ["started", "completed", "failed"] },
    "focusItem": {}, // used by mouse over event
    "keyNavigate": { sync: true } // this has to be sync for the mixin to prevent default behavior
  });

  var search = function search(params, scope){
    var searchParams = {
      q: params.text,
      per_page: params.qpp,
      types: params.allowedTypes,
      page: params.page
    };

    searchAPI.get(searchParams, function (body, response) {
      if(response && response.ok) {
        var total = parseInt(response.headers.total);
        this.completed(body, Object.assign({ total }, searchParams));
      } else {
        this.failed("Ocorreu um erro ao fazer a busca");
      }
    }.bind(scope));
  };

  actions.showSuggestions.listen(function(params){
    this.started(params.text, params.page);

    // TODO maybe it should be a mixin in the component
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function(){ search(params, this); }.bind(this), searchDelay);

  });

  actions.addOrganization.listen(function(params) {
    this.started();

    agendorAPI.post("/organizations", params, function(body, response) {
      try {
        mixpanelIncrementSuperProperty("Objetos adicionados", 1);
        mixpanel.track("Objeto adicionado", {
          "Objeto OA": "Empresa",
          "ID do cliente": window.loggedUserAccountId
        });
        mixpanel.people.increment("Objetos adicionados", 1);
      } catch (e) {
        captureError(e);
      }

      if (response && response.ok) {
        var entity = {
          id: body.id,
          img: body.logo,
          ligacao: null,
          ligacaoObj: null,
          nome: body.name,
          obj: "Empresa",
          type: "organization"
        };

        this.completed(entity);
      } else {
        this.failed("Não foi possível inserir esta empresa.");
      }

    }.bind(this));
  });

  actions.addPerson.listen(function(params) {
    this.started();

    agendorAPI.post("/people", params, function(body, response){
      try {
        mixpanelIncrementSuperProperty("Objetos adicionados", 1);
        mixpanel.track("Objeto adicionado", {"Objeto OA": "Pessoa"});
        mixpanel.people.increment("Objetos adicionados", 1);
      } catch (e) {
        captureError(e);
      }

      if (response && response.ok) {
        var entity = {
          id: body.id,
          img: body.avatar,
          ligacao: null,
          ligacaoObj: null,
          nome: body.name,
          obj: "Pessoa",
          type: "person"
        };

        this.completed(entity);
      } else {
        this.failed("Não foi possível inserir esta pessoa.");
      }

    }.bind(this));
  });

  actions.addDeal.listen(function(params) {
    this.started();

    agendorAPI.post("/deals", params, function(body, response){
      try {
        mixpanelIncrementSuperProperty("Objetos adicionados", 1);
        mixpanel.track("Objeto adicionado", {"Objeto OA": "Negocio"});
        mixpanel.people.increment("Objetos adicionados", 1);
      } catch (e) {
        captureError(e);
      }

      if (response && response.ok) {
        var entity = {
          id: body.id,
          img: null,
          ligacao: null,
          ligacaoObj: null,
          nome: body.title,
          obj: "Negocio",
          type: "deal"
        };

        this.completed(entity);
      } else {
        this.failed("Não foi possível inserir este negócio.");
      }

    }.bind(this));
  });

  return actions;
}

module.exports = MultiActionStore.factory(createActions);



// WEBPACK FOOTER //
// ./app/shared/actions/entity-suggestions-actions.js